import newBaseApi from "./newBase.api";

export const indicadorService = {
  ...newBaseApi,
  resource: "indicador-de-bem-estar",
  module: 'comunicacoes',
  profile: 'admin',
}